import React from "react";

type SpacingViewProps = {
  height: number | string;
};

const SpacingView: React.FC<SpacingViewProps> = ({ height }) => {
  return <div style={{ height }} />;
};

export default SpacingView;
